/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ServerObject} from "../models/server-object";
import {ServerObjectService} from "../services/server-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ServerObjectsResolver implements Resolve<ServerObject[]> {

  constructor(
    private mServerObjectService: ServerObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ServerObject[]> {
    try {
      return await this.mServerObjectService.getAllServerObjects();
    } catch (error) {
      console.error("Problem resolving Server Objects... Error: " + error, error);
    }
  }

}
